import { MatrixServices } from './../../../../../services/image/matrix.services'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { ModalService } from '../../../../../services/modal.service'
import { SharedServices } from '../../../../../services/shared.services'
import { FormBuilder } from '@angular/forms'
import { ClientTopServices } from '../../../../../services/ClientTop.services'
import { ActivatedRoute } from '@angular/router'
import * as moment from 'moment'
import { openActionSheet } from 'onsenui'
import Constants from '../../../../../commons/Constants'

@Component({
    selector: 'app-modal-client-detail-top-slideshow',
    templateUrl: './modal-client-detail-slideshow.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-slideshow.component.css',
    ],
})
export class ModalClientDetailSlideshowComponent implements OnInit, OnDestroy {
    en = {}
    showEN = true
    option_Slideshow = 'hidden'
    option_Slideshow_Face = ''
    option_Registration_Tooth = ''
    TabSlideshowClass
    docIcon

    valueEx1SliderRegister: Number = 0

    senMax: any = 100
    max: any = 5
    valChange: any = 3
    idClient: any
    resourceUrl = 'resource'

    height: any
    arrSlideshow: any[] = []
    countArrDataRegistration: any
    ValueAssignOneDistance: any
    arrRegistrationShow: any[] = []
    index: any = 0
    timeline: any
    showDate: any
    timestampStart: number
    dateStart: any
    tabName: any
    planClass: any

    arrTabSlideshow = Constants.TOP_MAIN_TABS

    emitTabName: any = {}
    isUpdateImageSet: Boolean = false
    arrayListNote: any[] = []
    arayListNote: any[] = []
    clientInfoUrl: any
    changeEmittedSlider: any
    changeEmittedIndex: any
    changeEmittedNoteList: any
    changeEmittedAllArrClientTo: any
    changeEmitChangeInfoUrlChange: any
    inPage: Boolean = false
    showTextareaNote: any
    textareaNote = true
    contentNote

    // arrTmpArrClientTop = [];

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                private route: ActivatedRoute,
                private matrixServices: MatrixServices) {
    }

    ngOnInit() {
        this.option_Slideshow = 'active'
        this.getTabRegistrationClass()
        this.option_Slideshow_Face = 'hidden'
        this.option_Registration_Tooth = 'hidden'
        this.showTextareaNote = 'hidden'
        this.valChange = 0
        this.countArrDataRegistration = 0
        this.route.parent.paramMap.subscribe(params => {
            if (params.get('id') != '') {
                this.idClient = params.get('id') ? params.get('id') : ''
                this.getRegistration()
                // this.getArrNoteList();
                this.getIndex()
            }
        })
        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalListImageTopComponent-keyTimeRecondMove') {
                        const timeRecornd = success[1]
                        const indexCurreny = success[2]
                        this.checkConfirmAlertMoveFormModalList(timeRecornd, indexCurreny)
                    }
                }
            },
        )

        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalListNoteTopComponent-ListNoteSelect') {
                        if (success[1]) {
                            this.arayListNote = success[1]
                            this.isUpdateImageSet = true
                        }
                    }
                }
            },
        )
        this.changeValueEx1SliderRegister()
    }

    ngOnDestroy() {
        this.clientTopServices.emitChangeSlider(null)
        if(this.changeEmittedIndex)
            this.changeEmittedIndex.unsubscribe()
        if(this.changeEmittedNoteList)
            this.changeEmittedNoteList.unsubscribe()
        if(this.changeEmittedSlider)
            this.changeEmittedSlider.unsubscribe()
        if(this.changeEmittedAllArrClientTo)
            this.changeEmittedAllArrClientTo.unsubscribe()
        if(this.changeEmitChangeInfoUrlChange)
            this.changeEmitChangeInfoUrlChange.unsubscribe()
        this.valChange = 0
        this.clientTopServices.slideshowActive = false
    }

    getIndex() {
        this.changeEmittedIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            if (infoIndex != null && infoIndex['index'] != undefined) {
                this.index = infoIndex['index']
                this.ValueAssignOneDistance = this.senMax / this.max
                this.valChange = this.ValueAssignOneDistance * this.index
            }
        })
    }

    // getArrNoteList() {
    //     this.changeEmittedNoteList = this.clientTopServices.changeEmittedNoteList$.subscribe(noteList => {
    //         console.log('noteList ', noteList);
    //         if (noteList != null && noteList['arrayNoteList'] != undefined) {
    //             this.arrayListNote = noteList['arrayNoteList'];
    //         }
    //     });
    // }

    getTabRegistrationClass() {
        const tabName: any = this.clientTopServices.getTabName()
        switch (tabName) {
            case 'face-1':
            case 'face-2':
            case 'face-3':
            case 'face-4':
            case 'face-5':
            case 'face-6':
            case 'face-all':
                this.TabSlideshowClass = 'option_0'
                this.tabName = 'face-all'
                this.emitTabName['tabName'] = 'face-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'tooth-right':
            case 'tooth-left':
            case 'tooth-front':
            case 'tooth-upper':
            case 'tooth-overjet':
            case 'tooth-lower':
            case 'tooth-all':
                this.TabSlideshowClass = 'option_1'
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'aligner-right':
            case 'aligner-left':
            case 'aligner-front':
            case 'aligner-upper':
            case 'aligner-overjet':
            case 'aligner-lower':
            case 'aligner-all':
                this.TabSlideshowClass = 'option_2'
                this.tabName = 'aligner-all'
                this.emitTabName['tabName'] = 'aligner-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'xp-1':
            case 'xp-2':
            case 'xp-3':
            case 'xp-4':
            case 'xp-5':
            case 'xp-6':
            case 'xp-all':
                this.TabSlideshowClass = 'option_3'
                this.tabName = 'xp-all'
                this.emitTabName['tabName'] = 'xp-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'dental-all':
                this.TabSlideshowClass = 'option_8'
                this.tabName = 'dental-all'
                this.emitTabName['tabName'] = 'dental-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'other-1':
            case 'other-2':
            case 'other-3':
            case 'other-4':
            case 'other-5':
            case 'other-6':
            case 'other-all':
                this.TabSlideshowClass = 'option_4'
                this.tabName = 'other-all'
                this.emitTabName['tabName'] = 'other-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'movie-1':
            case 'movie-2':
            case 'movie-3':
            case 'movie-4':
            case 'movie-5':
            case 'movie-6':
            case 'movie-all':
                this.TabSlideshowClass = 'option_5'
                this.tabName = 'movie-all'
                this.emitTabName['tabName'] = 'movie-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'smile':
                this.TabSlideshowClass = 'option_6'
                this.tabName = 'smile'
                this.emitTabName['tabName'] = 'smile'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'dsd':
                this.TabSlideshowClass = 'option_7'
                this.tabName = 'dsd'
                this.emitTabName['tabName'] = 'dsd'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            default:
                this.TabSlideshowClass = 'option_1'
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
        }
    }

    getAssignFromaTimesTamplast(timestampLast) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        if (timestampLast !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (timestampLast == arrayVlauseAllDate[j]['dateInit']) {
                    return arrayVlauseAllDate[j]['locationValue']
                }
            }
            return null
        }
    }

    checkConfirmAlertMoveFormModalList(timeRecornd, indexCurreny) {
        const assignCurenly = this.getvalChangeFromIndex(indexCurreny)
        const assign = this.getAssignFromaTimesTamplast(timeRecornd)
        this.checkAlertConFirmWhenNextDay(assignCurenly, assign)
    }

    checkAlertConFirmWhenNextDay(assignCurenly, assign) {
        this.getDateWhenChangeSliderRegister(assign)
    }

    prevDate(timestampAdd, day, option) {
        if (option === 'start') {
            if (this.showDate !== 'Click to Select') {
                if (day == 0) {
                    this.getDateWhenChangeSliderRegister(0)
                } else {
                    if (this.valChange < 0) {
                        this.getDateWhenChangeSliderRegister(0)
                    } else {
                        this.getDateWhenChangeSliderRegister(this.valChange - day)
                    }
                }
            }
        }
    }

    nextDate(timestampAdd, day, option) {
        if (option === 'start') {
            if (this.showDate !== 'Click to Select') {
                if (day == 100) {
                    this.getDateWhenChangeSliderRegister(100)
                } else {
                    this.getDateWhenChangeSliderRegister(this.valChange + day)
                }
            }
        }
    }

    getRegistration() {
        this.changeEmittedNoteList = this.clientTopServices.changeEmittedNoteList$.subscribe(arrayNoteList => {
            if (arrayNoteList != null && arrayNoteList['arrayNoteList'] != undefined) {
                this.arayListNote = arrayNoteList['arrayNoteList']
            }
        })
        this.changeEmitChangeInfoUrlChange = this.clientTopServices.changeEmitChangeInfoUrlChange$.subscribe(success => {
            if (success) {
                if (success[0] === 'ClientDetailComponent-clientInfoUrl') {
                    this.clientInfoUrl = success[1]
                }
            }
        })
        this.changeEmittedAllArrClientTo = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            // if (arrAll != null && arrAll['arrTmpArrClientTop']) {
            //     this.arrTmpArrClientTop = arrAll['arrTmpArrClientTop'];
            // }
            this.countArrDataRegistration = 0
            // const arrAll: any = this.clientTopServices.returnArrAll();
            if (arrAll != null && arrAll['slideshow'] != undefined) {
                this.arrSlideshow = arrAll['slideshow']
                this.countArrDataRegistration = this.arrSlideshow.length
                this.max = this.countArrDataRegistration - 1
                // const tmp: number = this.senMax / this.max;
                if (this.max > 0) {
                    this.ValueAssignOneDistance = this.senMax / this.max
                    this.valChange = this.ValueAssignOneDistance * this.index
                } else {
                    this.valChange = 0
                }
                // const assign = tmp;
                // this.ValueAssignOneDistance = assign;
                this.arrSlideshow = this.changeDateStringToDecoe(this.arrSlideshow)
                if (this.countArrDataRegistration > 0) {
                    this.arrSlideshow.sort((function(obj1, obj2) {
                        return obj1.dateStringToInit - obj2.dateStringToInit
                    }))
                    //edit 11/3/21
                    if(this.inPage){
                        this.clientTopServices.changeEmittedIndex$.next(null);
                    }
                    //end
                    this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
                        if (infoIndex != null && infoIndex['index'] != undefined) {
                            this.index = infoIndex['index']
                            this.arrRegistrationShow = this.arrSlideshow[this.index]
                            if (this.arrSlideshow[this.index] != undefined) {
                                this.contentNote = this.arrSlideshow[this.index]['note']
                                this.timeline = this.arrSlideshow[this.index]['dateStringToInit'] ? this.arrSlideshow[this.index]['dateStringToInit'] : ''
                                if (this.timeline != '') {
                                    const offset = new Date().getTimezoneOffset()
                                    const showdateAdd = moment(this.timeline).subtract(Math.abs(offset), 'ms').format('YYYY.MM.DD ddd')
                                    this.showDate = this.dateStart = showdateAdd
                                }
                            } else {
                                this.contentNote = null
                            }
                        }
                    })
                }
            }
        }, error1 => {
        })
    }

    changeDateStringToDecoe(arrRegistration) {
        const offset = new Date().getTimezoneOffset()
        for (let j = 0; j < arrRegistration.length; j++) {
            arrRegistration[j]['dateStringToInit'] = moment(arrRegistration[j]['dateString']).add(Math.abs(offset), 'ms').valueOf()
        }
        return arrRegistration
    }

    showLink() {
        const clientInfoUrl = this.clientInfoUrl
        const arrayClientInfoUrl = []
        for (let j = 0; j < clientInfoUrl.length; j++) {
            arrayClientInfoUrl.push(
                {
                    label: clientInfoUrl[j]['title'],
                },
            )
        }
        const labelCancel = { label: 'Cancel', icon: 'md-close' }
        arrayClientInfoUrl.push(labelCancel)
        openActionSheet({
            title: 'Open URL',
            cancelable: true,
            buttons: arrayClientInfoUrl,
            callback: i => {
                for (let k = 0; k < clientInfoUrl.length; k++) {
                    if (i === k) {
                        window.open(clientInfoUrl[k]['url'])
                    }
                }
            },
        })
    }

    toggleTabRegistrationItem(id, event) {
        this.inPage = true;
        this.countArrDataRegistration = 0
        this.TabSlideshowClass = id
        const emitStatus: any = {}
        if (this.option_Slideshow_Face == 'active') {
            emitStatus['status'] = true
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        } else {
            emitStatus['status'] = false
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        }
        const tmpTabName = this.clientTopServices.functReturnTabName()
        if (tmpTabName['tabName'] != this.tabName) {
            this.matrixServices.resetMatrix()
        }
        switch (this.TabSlideshowClass) {
            case 'option_0':
                this.tabName = 'face-all'
                break
            case 'option_1':
                this.tabName = 'tooth-all'
                break
            case 'option_2':
                this.tabName = 'aligner-all'
                break
            case 'option_3':
                this.tabName = 'xp-all'
                break
            case 'option_4':
                this.tabName = 'other-all'
                break
            case 'option_5':
                this.tabName = 'movie-all'
                break
            case 'option_6':
                this.tabName = 'smile'
                break
            case 'option_7':
                this.tabName = 'dsd'
                break
            case 'option_8':
                this.tabName = 'dental-all'
                break
            default:
                this.tabName = 'tooth-all'
                break
        }
        this.emitTabName['tabName'] = this.tabName
        this.clientTopServices.emitChangeTabName(this.emitTabName)
    }

    createArraySlideRange() {
        const arrayVlauseAllDate = []
        const arrayDateString = this.arrSlideshow

        for (let i = 0; i < arrayDateString.length; i++) {
            const tmp: number = this.senMax / this.max
            // const assignCalculate = Math.round(tmp);
            const assignCalculate = tmp
            const valueInChangeSlider = i * assignCalculate
            arrayVlauseAllDate.push({
                location: i,
                locationValue: valueInChangeSlider,
                dateInit: arrayDateString[i].dateStringToInit,
                dateText: arrayDateString[i].dateString,
            })
        }
        return arrayVlauseAllDate
    }

    getvalChangeFromIndex(index) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        if (index !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (index == arrayVlauseAllDate[j]['location']) {
                    return arrayVlauseAllDate[j]['locationValue']
                }
            }
            return null
        }
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    getAssignCalculateChange(resSliderClientTop) {
        const value: any = resSliderClientTop
        const tmp: number = (value / this.senMax) * this.max
        this.index = Math.round(tmp)
        const tmpEarch: number = this.senMax / this.max
        // const assignCalculate = Math.round(tmpEarch);
        const assignCalculate = tmpEarch
        const assignLocal = this.index * assignCalculate
        return assignLocal
    }

    getvalIndexNextFromaAssign(assign) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        if (assign !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (assign == arrayVlauseAllDate[j]['locationValue']) {
                    return arrayVlauseAllDate[j]['location']
                } else if (assign === 100) {
                    return arrayVlauseAllDate[arrayVlauseAllDate.length - 1]['location']
                }
            }
            return null
        }
    }

    changeValueEx1SliderRegister() {
        this.changeEmittedSlider = this.clientTopServices.changeEmittedSlider$.subscribe(res => {
            if (res != null && res['sliderClientTop'] !== undefined) {
                const assign = this.getAssignCalculateChange(res['sliderClientTop'])
                this.valChange = assign
                this.getDateWhenChangeSliderRegister(assign)
            }
        })
    }

    toggleTabItem(id, option, event) {
        this.planClass = id
    }

    selectListImageTop() {
        // const listDataImageTopClient = ['listDataImageTopClient', this.arrSlideshow, this.idClient, this.index, this.arayListNote, this.arrTmpArrClientTop];
        const listDataImageTopClient = ['listDataImageTopClient', this.arrSlideshow, this.idClient, this.index, this.arayListNote]
        this.clientTopServices.emitChangeListTopImageData(listDataImageTopClient)
    }

    getDateWhenChangeSliderRegister(assign) {
        const arrayVlauseAllDate = this.createArraySlideRange()
        assign = Math.abs(assign)
        if (assign !== '') {
            for (let j = 0; j < arrayVlauseAllDate.length; j++) {
                if (assign == arrayVlauseAllDate[j]['locationValue'] || Math.round(assign) == Math.round(arrayVlauseAllDate[j]['locationValue'])) {
                    const showdateAdd = moment(arrayVlauseAllDate[j]['dateInit']).format('YYYY.MM.DD ddd')
                    this.showDate = this.dateStart = showdateAdd
                    this.valChange = assign
                    this.index = j
                    this.arrRegistrationShow = this.arrSlideshow[this.index]
                    const emitIndex: any = {}
                    emitIndex['index'] = this.index
                    this.clientTopServices.emitChangeIndex(emitIndex)
                } else if (assign === arrayVlauseAllDate[j]['dateInit']) {
                    const showdateAdd = moment(arrayVlauseAllDate[j]['dateInit']).format('YYYY.MM.DD ddd')
                    this.showDate = this.dateStart = showdateAdd
                    this.valChange = arrayVlauseAllDate[j]['locationValue']
                    this.index = j
                    this.arrRegistrationShow = this.arrSlideshow[this.index]
                    const emitIndex: any = {}
                    emitIndex['index'] = this.index
                    this.clientTopServices.emitChangeIndex(emitIndex)
                }
            }
        }
    }


    toggleProfile(event) {
        this.docIcon = (event === -1 ? 0 : -1)
        const emitStatus: any = {}
        if (this.docIcon === 0) {
            this.option_Slideshow_Face = 'active'
            emitStatus['status'] = true
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        } else {
            this.option_Slideshow_Face = 'hidden'
            emitStatus['status'] = false
            this.clientTopServices.emitChangeChangeStatus(emitStatus)
        }
    }

    showTextNote(data: boolean) {
        if (data === true) {
            this.showTextareaNote = 'active'
        } else {
            this.showTextareaNote = 'hidden'
        }
        this.textareaNote = !data
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/slideshow/modal-client-detail-slideshow.component.ts